import { AgGridCustomFilterAdapter } from 'components/CustomTableFilter';
import type { CatalogUerBaseCostWorkScopeBaseData } from 'gql/graphql';

import type { ColDef } from 'ag-grid-community';
import { useMemo } from 'react';

import type { TNestedColumns } from '../helpers';

export const useCatalogBaseCostWorkScopesColumns = ({ onFiltersUpdated, currentFilterData }: TNestedColumns) =>
    useMemo<ColDef<CatalogUerBaseCostWorkScopeBaseData>[]>(
        () => [
            {
                field: 'number',
                headerName: '№ пп',
                width: 100,
                spanHeaderHeight: true,
            },
            {
                field: 'name',
                headerName: 'Наименование',
                flex: 1,
                filter: AgGridCustomFilterAdapter,
                filterParams: {
                    hideTableHeader: true,
                    changeFilterHandler: onFiltersUpdated,
                    filterItems: currentFilterData?.map(({ name }) => ({ label: name })),
                    columns: [
                        {
                            headerName: 'Наименование',
                            field: 'label',
                            checkboxSelection: true,
                            width: 400,
                        },
                    ],
                    isClientSideSearch: true,
                    childFieldAccessor: 'label',
                },
            },
        ],
        [currentFilterData, onFiltersUpdated],
    );
